import { useRef } from 'react';
import Fila from 'components/corporatiu/Fila';
import Enllac from 'components/corporatiu/Enllac/Enllac';
import Icona from 'components/corporatiu/Icona/';
import Imatge from 'components/corporatiu/Imatge';
import styles from './prepeu.module.scss';

const PrepeuMarato = (props) => {
    return (
        <div className={styles.prepeuWrapper}>
            <Fila tipus='fixed'>
                <ul className={styles.prepeuMarato}>
                    <li className={styles.peuMaratoItem}>
                        <Enllac href='/tv3/marato/que-es-la-marato/'>
                            <Icona className={styles.icona} icona='people' isBlanc={false} inline={true} />
                            Què és La Marató?
                        </Enllac>
                    </li>
                    <li className={styles.peuMaratoItem}>
                        <Enllac href='/tv3/marato/dades/'>
                            <Icona className={styles.icona} icona='info' isBlanc={false} inline={true} />
                            Vols rebre informació?
                        </Enllac>
                    </li>
                    <li className={styles.peuMaratoItem}>
                        <Enllac href='/atencio/'>
                            <Icona className={styles.icona} icona='bubbles' isBlanc={false} inline={true} />
                            Contacta
                        </Enllac>
                    </li>
                    <li className={styles.peuMaratoItem}>
                        <Enllac href='/tv3/marato/fundacio/'>
                            <Imatge
                                src='https://statics.3cat.cat/recursos/marato/img/logos/logo-fundacio30_monocrom.svg'
                                alt='Fundació la Marató de 3Cat'
                                width={149}
                                height={43}
                            ></Imatge>
                        </Enllac>
                    </li>
                </ul>
            </Fila>
        </div>
    );
};

export default PrepeuMarato;
